import { render, staticRenderFns } from "./skuDetails1.vue?vue&type=template&id=2cf0e567&scoped=true&"
import script from "./skuDetails1.vue?vue&type=script&lang=js&"
export * from "./skuDetails1.vue?vue&type=script&lang=js&"
import style0 from "./skuDetails1.vue?vue&type=style&index=0&id=2cf0e567&scoped=true&lang=css&"
import style1 from "./skuDetails1.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf0e567",
  null
  
)

export default component.exports